export interface ICommonTranslationUserTypes {
    [key: string]: string;
    150190004: string;
    150190005: string;
    150190006: string;
    150190102: string;
    150190101: string;
    150190100: string;
    150190106: string;
    150190108: string;
    150190105: string;
    150190104: string;
    150190103: string;
    150190107: string;
    150190109: string;
    250190103: string;
    250190104: string;
    250190105: string;
    250190107: string;
    250190109: string;
}

const initTranslationUserTypes: ICommonTranslationUserTypes = {
    150190004: '',
    150190005: '',
    150190006: '',
    150190102: '',
    150190101: '',
    150190100: '',
    150190106: '',
    150190108: '',
    150190105: '',
    150190104: '',
    150190103: '',
    150190107: '',
    150190109: '',
    250190103: '',
    250190104: '',
    250190105: '',
    250190107: '',
    250190109: '',
};

export default initTranslationUserTypes;
